import { TmApiClientError } from '@/core/error/transport/tmApiClientError'

export class TmApiSenderIdMarkAsPendingError extends TmApiClientError {
  public name = 'TmApiSenderIdMarkAsPendingError'

  public shouldBeMonitored(): boolean {
    return false
  }
}
